import { useState } from "react";
import { TimeInputState } from "./commonTypes";
import {
  validateTimeFormat,
  formatTimeInput,
  convertTimeToSeconds,
} from "./timeUtils";

interface UseTimeInputOptions {
  onTimeChange?: (seconds: number) => void;
}

export function useTimeInput({
  onTimeChange,
}: UseTimeInputOptions = {}): TimeInputState & {
  setTimeInputValue: (value: string) => void;
} {
  const [timeInputValue, setTimeInputValue] = useState("");

  const handleTimeInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = formatTimeInput(e.target.value);

    if (validateTimeFormat(newValue)) {
      setTimeInputValue(newValue);

      // Only convert to seconds if we have a complete valid time
      if (newValue.match(/^\d{1,2}:[0-5]\d$/)) {
        const seconds = convertTimeToSeconds(newValue);
        onTimeChange?.(seconds);
      }
    }
  };

  return {
    timeInputValue,
    setTimeInputValue,
    handleTimeInputChange,
    validateTimeFormat,
    formatTimeInput,
  };
}
